module.exports = "/_next/static/media/7c66c80a03162e3bde23751c9724221c.png";